

<template>
	<section>
		<!-- <header class="detail-title font-bold">调拨产品行</header> -->
		<div v-if="type==='query'">
			<aside class="button-group text-right margin-top-10">
				<vButton theme="info" @click="handleDeliverModal">查看发货详情</vButton>
				<vButton theme="warning" @click="handleBoxingModal">查看装箱</vButton>
				<vButton theme="success" @click="download">导出明细</vButton>
				<vButton theme="primary" @click="downloadBoxing">导出装箱明细</vButton>
			</aside>
			<footer class="margin-left-30 margin-bottom-10">
				总计：SKU种数合计：{{dataList.length}}&nbsp;&nbsp;
				计划出库数量总计：{{dataList|handleTotalDataList('outPlanqty')}}&nbsp;&nbsp;
				实际出库数量总计：{{dataList|handleTotalDataList('qtyOutbound')}}&nbsp;&nbsp;
				实际接收数量总计：{{dataList|handleTotalDataList('qtyInbound')}}&nbsp;&nbsp;
			</footer>
		</div>
		<div v-else class="margin-top-10">
			<vFormItem label-width="100" inline label="ERP SKU:" class="margin-bottom-10">
				<vSelect
					v-if="isOnsiteWarehouse"
					v-model="formData.erpSku"
					filterable
					dropStyle="width:520px;"
					@on-attach="getProductId"
				>
					<vOption v-for="item in skuList" :key="item.value" :value="item.value" :attach="item.productId">
						<span class="color-error">{{item.value}}</span>
						<span v-if="item.name">- {{item.name}}</span>
					</vOption>
				</vSelect>
				<vInput v-else v-model="formData.erpSku" readonly>
					<vIcon
						type="search"
						center
						slot="suffix"
						style="padding:6px;"
						size="18"
						@click.native="handleErpList"
					/>
				</vInput>
			</vFormItem>
			<vFormItem label-width="100" inline label="可用库存:">
				<span>{{formData.qty!==''?formData.qty:'-'}}</span>
			</vFormItem>
			<vFormItem label-width="100" inline label="出库数量:">
				<vInputNumber
					clearable
					v-model="formData.outPlanqty "
					:min="0"
					:max="isOnsiteWarehouse?null:formData.qty"
				/>
			</vFormItem>
			<vButton class="margin-left-10" theme="primary" @click="addItem">逐个添加</vButton>
			<vButton class="margin-left-10" theme="info" @click="handleUpload">批量导入</vButton>
			<footer class="margin-bottom-10 margin-left-20">
				<vButton @click="clearDataList" theme="error">清空所有</vButton>
				总计：SKU种数合计：{{dataList.length}}&nbsp;&nbsp;
				出库总数量：{{dataList|handleTotalDataList}}
			</footer>
		</div>
		<vTable
			style="margin:0 16px"
			:columns="columns"
			:data="dataList"
			size="small"
			ref="table"
			border
			stripe
		></vTable>
	</section>
</template>


<script>
import { HttpInventoryData } from '@/service/allotment/transfer'
import { HttpInventoryErpSkuList, HttpSkuList, HttpAllotBoxing, HttpAllotDeliver } from '@/service/allotment/allots'
import compUpload from '@components/templates/upload'
import TableList from '@components/templates/tablelist'
import compBoxingdetail from './boxingdetail'

export default {
	props: ['type', 'inventoryType', 'orgWarehouseId', 'transferOutboundPlanNo', 'transferId', 'lineId', 'isOnsiteWarehouse'],
	data() {
		return {
			dataList: [],
			skuList: [],
			formData: {
				qty: '',
			},
			// erpSkuList: []
		};
	},
	filters: {
		handleTotalDataList(data = [], type = "outPlanqty") {
			let total = 0;
			data.forEach(item => {
				total += item[type];
			});
			return total;
		},
	},
	watch: {
		lineId(val, old) {
			if (val && this.isOnsiteWarehouse) this.getErpSkuList();
		},
		isOnsiteWarehouse(val) {
			if (val && this.lineId) this.getErpSkuList();
		}
	},

	methods: {
		getProductId(productId) {
			this.formData.productId = productId;
		},
		getErpSkuList() {
			HttpSkuList({ lineId: this.lineId }).then(res => {
				this.skuList = res.data.map(function (item) {
					return {
						value: item.erpSku,
						name: item.name,
						productId: item.id
					}
				})
			})
		},
		handleDeliverModal() {
			const attrs = {
				columns: [{
					title: "调拨出库单号",
					key: 'transferOutboundNo',
				}, {
					title: "Tracking No.",
					key: 'trackingNo'
				}, {
					title: "承运商",
					key: 'carrierCode',
				}, {
					title: "预约送仓时间",
					key: 'appointmentAt',
				}, {
					title: "预约提货时间",
					key: 'appointmentShipAt',
				}, {
					title: "箱条码",
					key: 'cartonBarcode',
				}, {
					title: "托盘条码",
					key: 'palletBarcode',
				}, {
					title: "实际提货时间",
					key: 'actualShipAt',
				}],
				initFormData: { transferOutboundPlanNo: this.transferOutboundPlanNo },
				ajaxRequest: HttpAllotDeliver,
				startUp: true
			}
			this.$VModal.default({
				title: "发货详情",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement(TableList, { attrs })
				}
			})
		},
		handleUpload() {
			const warehouseId = this.orgWarehouseId, inventoryType = this.inventoryType;
			if (!warehouseId) return this.$VMessage.warning('请先填写仓库');
			const data = {
				attrs: {
					data: { contextId: global.SYSID, warehouseId, inventoryType },
					action: process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/importItems",
					name: "excelFile",
					download() {
						this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/itemTemplate", 'download')
					},
				},
				on: {
					'on-success': (res) => {
						this.$VModal.destroy();
						this.dataList = res.data;
					},
					'on-cancel': () => {
						this.$VModal.destroy();
					}
				}
			}
			this.$VModal.default({
				title: "导入数据",
				width: 460,
				showFooter: false,
				render: (h, props) => {
					return h(compUpload, data)
				}
			})
		},
		handleBoxingModal() {
			this.$VModal.default({
				title: "装箱信息",
				width: 1000,
				showFooter: false,
				render: (h) => {
					return this.$createElement(compBoxingdetail, {
						props: {
							transferOutboundPlanNo: this.transferOutboundPlanNo
						}
					})
				}
			})
		},
		download() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/exportTransferOutboundPlanItems", { transferOutboundPlanNo: this.transferOutboundPlanNo }, 'download')
		},
		downloadBoxing() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/exportItemBox", {
				transferId: this.transferId
			}, 'download');
		},
		clearDataList() {
			this.dataList = []
		},
		addItem() {
			const { erpSku, outPlanqty, qty, productId } = this.formData
			if (erpSku && outPlanqty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.erpSku === erpSku
				});
				if (erpSkuData) {
					erpSkuData.outPlanqty += outPlanqty;
					if (!this.isOnsiteWarehouse && erpSkuData.outPlanqty > qty) erpSkuData.outPlanqty = qty;
				} else {
					this.dataList.push({ erpSku, outPlanqty, productId })
				}
				this.formData = { qty: '' };
				return;
			}
			this.$VMessage.warning('请填写ERP SKU和出库数量');
		},
		removeItem(index) {
			this.dataList.splice(index, 1)
		},
		getInventory(val) {
			const erpSku = this.formData.erpSku;
			this.erpSkuList.some((item) => {
				if (item.sku === erpSku) {
					this.formData = { ...this.formData, ...item }
					return true;
				}
			})
		},

		handleErpList() {
			if (!this.orgWarehouseId || !this.lineId) return this.$VMessage.warning('请填写项目和调出仓库');
			const attrs = {
				columns: [{
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: "可用库存",
					key: 'qty'
				}, {
					title: "描述",
					key: 'nameEn'
				}, {
					title: "操作",
					width: 120,
					align: 'center',
					render: (h, { row }) => {
						return h('vButton', {
							props: {
								theme: 'primary'
							},
							nativeOn: {
								click: () => {
									this.formData = Object.assign(this.formData, row, { erpSku: row.sku });
									this.$VModal.destroy();
								}
							}
						}, "选择")
					}
				}],
				Searchs: {
					show: true,
					style: "border:none;",
					labelWidth: 'auto',
					align: "left"
				},
				SearchsData: [{
					label: "ERP SKU",
					tag: 'vInput',
					key: 'CN_sku',
					show: true,
				}
				// , {
				// 	label: "描述",
				// 	tag: 'vInput',
				// 	key: 'CN_productsEntity.nameEn',
				// 	show: true,
				// }
				],
				initFormData: {
					'search[EQ_inventoryType]': this.inventoryType,
					'search[EQ_orgWarehouseId]': this.orgWarehouseId,
					'search[EQ_groupCode]': this.lineId,
				},
				ajaxRequest: HttpInventoryErpSkuList,
				interceptResponse: function (data) {
					this.dataList = data.inventoryData || [];
				},
			}
			this.$VModal.default({
				title: "请选择产品",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement(TableList, { attrs })
				}
			})
		},
	},
	computed: {
		columns() {
			return this.type !== 'query' ? [{
				title: "ERP SKU",
				key: 'erpSku'
			}, {
				title: "出库数量",
				key: 'outPlanqty'
			}, {
				title: '操作',
				align: 'center',
				render: (h, { index }) => {
					return <vButton theme="error" nativeOnClick={this.removeItem.bind(this, index)}>删除</vButton>
				}
			}] :
				[{
					title: "ERP SKU",
					key: 'erpSku'
				}, {
					title: "计划出库数量",
					key: 'outPlanqty'
				}, {
					title: "实际出库数量",
					key: 'qtyOutbound'
				}, {
					title: "实际接收数量",
					key: 'qtyInbound'
				}, {
					title: "最新接收时间",
					key: 'updatedAt'
				}]
		}
	},
};
</script>